import React, { useEffect } from "react"
import { withRouter } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"

import "./style.scss"
import "../../assets/scss/custom/structure/responsiveness-theme.scss"
import {
   changeLayout,
   changeSidebarTheme,
   changeSidebarThemeImage,
   changeSidebarType,
   changeTopbarTheme,
   changeLayoutWidth,
   showRightSidebarAction,
} from "../../store/actions"
import Header from "./Header"
import Sidebar from "./Sidebar"
import RightSidebar from "../CommonForBoth/RightSidebar"
import DownTimeBar from "components/DownTimeBar/DownTimeBar"

const Layout = props => {
   const dispatch = useDispatch()

   const {
      isPreloader,
      leftSideBarThemeImage,
      layoutWidth,
      leftSideBarType,
      topbarTheme,
      showRightSidebar,
      leftSideBarTheme,
   } = useSelector(state => ({
      isPreloader: state.Layout.isPreloader,
      leftSideBarThemeImage: state.Layout.leftSideBarThemeImage,
      leftSideBarType: state.Layout.leftSideBarType,
      layoutWidth: state.Layout.layoutWidth,
      topbarTheme: state.Layout.topbarTheme,
      showRightSidebar: state.Layout.showRightSidebar,
      leftSideBarTheme: state.Layout.leftSideBarTheme,
   }))

   const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

   const toggleMenuCallback = () => {
      if (leftSideBarType === "default") {
         dispatch(changeSidebarType("condensed", isMobile))
      } else if (leftSideBarType === "condensed") {
         dispatch(changeSidebarType("default", isMobile))
      }
   }

   const hideRightbar = event => {
      var rightbar = document.getElementById("right-bar")
      if (rightbar && rightbar.contains(event.target)) {
         return
      } else {
         dispatch(showRightSidebarAction(false))
      }
   }

   useEffect(() => {
      document.body.addEventListener("click", hideRightbar, true)
   }, [])

   useEffect(() => {
      window.scrollTo(0, 0)
   }, [])

   useEffect(() => {
      dispatch(changeLayout("vertical"))
   }, [dispatch])

   useEffect(() => {
      if (leftSideBarTheme) {
         dispatch(changeSidebarTheme(leftSideBarTheme))
      }
   }, [leftSideBarTheme, dispatch])

   useEffect(() => {
      if (leftSideBarThemeImage) {
         dispatch(changeSidebarThemeImage(leftSideBarThemeImage))
      }
   }, [leftSideBarThemeImage, dispatch])

   useEffect(() => {
      if (layoutWidth) {
         dispatch(changeLayoutWidth(layoutWidth))
      }
   }, [layoutWidth, dispatch])

   useEffect(() => {
      if (leftSideBarType) {
         dispatch(changeSidebarType(leftSideBarType))
      }
   }, [leftSideBarType, dispatch])

   useEffect(() => {
      if (topbarTheme) {
         dispatch(changeTopbarTheme(topbarTheme))
      }
   }, [topbarTheme, dispatch])

   return (
      <>
         <div id="layout-wrapper">
            <Header toggleMenuCallback={toggleMenuCallback} />
            <Sidebar
               theme={leftSideBarTheme}
               type={leftSideBarType}
               isMobile={isMobile}
            />
            <div className="main-content gt-content-wrapper">
               {props.children}
            </div>
         </div>
         {showRightSidebar ? <RightSidebar /> : null}
      </>
   )
}

export default withRouter(Layout)
